import Article from './article'
export default [
  {
    path: '/article',
    name: 'home-article',
    component: Article
  }
]



// WEBPACK FOOTER //
// ./src/components/article/article-router.js